import React from 'react'
import { Link } from 'react-router-dom'

const ServicesCard = props => {
    return (
            <div className="landing-container-services-card">
                <Link to={props.to}>
                    <h1>{props.title}</h1>
                </Link>
                <p>{props.desc}</p>
                <i className={`${props.icon} icon-container`} />
            </div>
    )
}

export default ServicesCard
